"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotEmpty = exports.isEmpty = void 0;

var _type = require("../type/type");

/**
 * Check if variable is considered empty
 *
 * @param   {Any}      source  Source input
 *
 * @return  {boolean}  True if empty, False otherwise
 *
 * @tag Core
 * @signature (source: any): boolean
 *
 * @example
 * isEmpty({})               // true
 * isEmpty(1)                // false
 * isEmpty(false)            // false
 * isEmpty("")               // true
 * isEmpty(null)             // true
 * isEmpty(undefined)        // true
 * isEmpty([])               // true
 * isEmpty(NaN)              // true
 * isEmpty(/[A-z]/)          // false
 * isEmpty(new Date())       // false
 * isEmpty(() => {})         // false
 * isEmpty(Promise.resolve() // false
 */
var isEmpty = function isEmpty(source) {
  var sourceType = (0, _type.type)(source);
  var byType = {
    Null: function Null() {
      return true;
    },
    Undefined: function Undefined() {
      return true;
    },
    Number: function (_Number) {
      function Number() {
        return _Number.apply(this, arguments);
      }

      Number.toString = function () {
        return _Number.toString();
      };

      return Number;
    }(function () {
      return Number.isNaN(source);
    }),
    String: function String() {
      return source === "";
    },
    Array: function Array() {
      return source.length === 0;
    },
    Object: function (_Object) {
      function Object() {
        return _Object.apply(this, arguments);
      }

      Object.toString = function () {
        return _Object.toString();
      };

      return Object;
    }(function () {
      return Object.keys(source).length === 0;
    })
  };
  return byType[sourceType] ? byType[sourceType]() : false;
};

exports.isEmpty = isEmpty;

var isNotEmpty = function isNotEmpty(source) {
  return !isEmpty(source);
};

exports.isNotEmpty = isNotEmpty;